<template>
  <div style="padding-bottom: 2rem;">
    <div class='top'>检查记录</div>
    <div class='record'>
      <div class='record-item'>
        <div>姓名</div>
        <div>性别</div>
        <div>检查日期</div>
        <div>检查码</div>
        <div>档案</div>
      </div>
      <div v-for='(item, index) in recordList.list' :key='index' class='record-item'>
        <div>{{ item.studentName }}</div>
        <div>{{ item.sex }}</div>
        <div @click='goDetail(item)'>{{ item.recordDate | formatDate }}</div>
        <div @click='goQr(item)'><i class="van-icon van-icon-qr ewm"></i></div>
        <div @click='goDetail(item)'>查看</div>
      </div>
      <div class='tip'>
        <div class='tip-info'>注：点击检查日期查看当日检查结果</div>
      </div>
    </div>
    <div class="loading" v-if="showLoading">
      <van-loading type="spinner" />数据加载中...
    </div>
    <div v-if="showEwm" class="maskbox">
      <div class="mask">
        <div class="maskclose" @click="showEwm = false">
          <img src="../assets/img/close.png" />
        </div>
        <div class="codetip">{{ studentName }}</div>
        <div id="qrCode" class="ewmcode" ref="qrCodeDiv"></div>
        <div class="codetip">
          <div>检查时，请出示此二维码。</div>
          <div style="text-align:left;">离院后如需咨询医生，请关闭此页，点击公众号左下角“在线咨询”，按提示选择医生咨询</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2';
export default {
  name: "record",
  data() {
    return {
      recordList: { list: '' },
      showEwm: false,
      studentName: '',
      showLoading: 1,
      code: '',
      accountId: '',
      hospitalId: ''
    };
  },
  mounted() {
    this.accountId = this.$route.query.accountId;
    this.hospitalId = this.$route.query.hospitalId;
    this.getRecord();
    this.getTitle();
  },
  methods: {
    /**
     * 获取记录
    */
    async getRecord() {
      let auth = this.$createAuth(this.$md5);
      let data = {
        auth: auth.code,
        time: auth.time,
        name: this.$route.query.name,
        code: this.$route.query.code,
        idCard: this.$route.query.idCard,
        phone: this.$route.query.phone,
        accountId: this.accountId
      }
      if (this.hospitalId && this.hospitalId != undefined && this.hospitalId != 'undefined') data.hospitalId = this.hospitalId;
      let result = await this.$http.post(this.$url.queryListByAppid, data);
      //18701482544
      if (result.message === 'Error: Miss auth parameter.') {
        this.getRecord();
      } else {
        this.showLoading = 0;
        this.recordList.list = result.data.studentList;
        let list = result.data.studentList;
        if (list.length === 0) this.$toast("未检查到该检查人信息!")
        if (list.length == 1) {
          let item = list[0]
          if (item.screenType == 0) {
            let hospitalId = item.hospitalId;
            if (hospitalId == null || typeof (hospitalId) == undefined) hospitalId = '';
            let sid = item.uid;
            let activityId = item.activityId == null ? '' : item.activityId
            if (typeof (activityId) == "undefined") activityId = ''
            this.$router.push(`/detail?sid=${sid}&screenType=${item.screenType}&activityId=${activityId}&accountId=${this.$route.query.accountId}&hospitalId=${hospitalId}`);
          }
        }
      }
    },
    goQr(item) {
      let _this = this;
      let sid = item.uid;
      this.showEwm = true;
      this.studentName = item.studentName;
      let url = item.codeUrl;
      setTimeout(function () {
        new QRCode(_this.$refs.qrCodeDiv, {
          text: url,
          width: 135,
          height: 135,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
        });
      }, 500)

    },
    /**
     * 跳转详情页面
    */
    goDetail(item) {
      let hospitalId = item.hospitalId;//this.$route.query.hospitalId;
      if (hospitalId == null || typeof (hospitalId) == undefined) hospitalId = '';

      let sid = item.uid;
      let activityId = item.activityId
      if (typeof (activityId) == "undefined") activityId = ''
      this.$router.push(`/detail?sid=${sid}&screenType=${item.screenType}&activityId=${activityId}&accountId=${this.$route.query.accountId}&hospitalId=${hospitalId}`);

    },
    async getTitle() {
      let auth = this.$createAuth(this.$md5);
      let result = await this.$http.get(this.$url.getTitle, {
        accountId: this.accountId,

        auth: auth.code,
        time: auth.time
      })
      if (result.message === 'Error: Miss auth parameter.') {
        this.getTitle();
      } else {
        document.title = result.data.title;
      }
    }
  },
  filters: {
    formatAge(value) {
      return value < 0 || value == "" ? 0 : value;
    },
    formatWeight(value) {
      return value == null ? '' : value + 'kg';
    },
    formatHeight(value) {
      return value == null ? '' : value + 'cm';
    },
    formatVal(value) {
      return value == null ? '' : value;
    },
    formatDate(value) {
      return value.length > 10 ? value.substring(0, 10) : value;
    }
  }
};
</script>
<style scope lang="less">
.top {
  padding: 0.3rem;
  font-size: 0.32rem;
  font-weight: bold;
  border-bottom: 1px solid #dddddd;
}

.record {
  width: 100%;

  .record-item {
    display: flex;

    div {
      height: 0.8rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      line-height: 0.8rem;
      border-right: 1px solid #eeeeee;
      border-bottom: 1px solid #dddddd;

      &:nth-child(5n+1) {
        width: 1.5rem;
      }

      &:nth-child(5n+2) {
        width: 1rem;
      }

      &:nth-child(5n+3) {
        width: 2rem;
      }

      &:nth-child(5n+4) {
        width: 1.5rem;
      }

      &:nth-child(5n+5) {
        width: 1.5rem;
      }
    }

    &:nth-child(odd) {
      background: #eeeeee;
    }
  }
}

.tip {
  margin: 0.1rem 0.3rem;
  text-align: left;
  height: 0.6rem;
  line-height: 0.6rem;

  .tip-info {
    color: #999999;
    font-size: 0.26rem;
  }

  .tip-query {
    margin-top: 1rem;
    text-align: center;
  }

  .tip-xieyi {
    position: fixed;
    padding: 0.5rem 0;
    left: 0;
    bottom: 0.3rem;
    width: 100%;
    background: #fff;
    text-align: center;
    font-size: 0.28rem;
  }
}

.ewm {
  margin-top: 0.15rem;
  font-size: 18px;
}

.maskbox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  background: rgba(0, 0, 0, 0.5);

  .mask {
    width: 6rem;
    height: 7rem;
    margin: 30% auto;
    background: #fff;
    border-radius: 5px;
  }

  .maskclose {
    width: 100%;
    height: 0.5rem;

    img {
      width: 0.3rem;
      margin: 0.3rem;
      margin-left: 5.2rem;
    }
  }

  .codetip {
    width: 5rem;
    margin: 0 auto 0.3rem;
    line-height: 1.5em;
    font-size: 0.3rem;
  }
}

.ewmcode {
  width: 150px;
  height: 150px;
  margin: 0 auto;
}
</style>
